module.exports = __webpack_public_path__ + "img/appAsset--suppliers-ax.cad702d3.svg";